import React, { useState } from 'react';
import './Secondbar.css'
import { Link } from 'react-router-dom'

const Secondbar = () => {

  const [menu,setMenu] = useState("")

  return (
     <div className='second-navbar'>
      <ul className='secondbar-link'>
        
        <li onClick={() => setMenu("hideamic")} className={menu === "hideamic" ? "active" : ""}>
          <Link to="/hideamic">Hide-a-mic</Link>
        </li>
        <li onClick={() => setMenu("radius")} className={menu === "radius" ? "active" : ""}>
          <Link to="/radiuswindshield">Radius Windshield</Link>
        </li>
        <li onClick={() => setMenu("ursa")} className={menu === "ursa" ? "active" : ""}>
          <Link to="/ursa">Ursa</Link>
        </li>
        <li onClick={() => setMenu("viviana")} className={menu === "viviana" ? "active" : ""}>
          <Link to="/viviana">Viviana</Link>
        </li>
        
       
        
        <li onClick={() => setMenu("brand")} className={menu === "brand" ? "active" : ""}>
          <Link to="/brand">Brands</Link>
        </li>
        <li onClick={() => setMenu("accessories")} className={menu === "accessories" ? "active" : ""}>
          <Link to="/accessories">Accessories</Link>
        </li>
      </ul>
    </div>
  );
}

export default Secondbar